/* eslint-disable no-redeclare */
import React, { useState, useEffect, useContext } from 'react'
import { RouteLink, Grid, GridCell } from 'common-controls/Core/index'
import { ah, sh, ReduxWrapper, compose } from 'common-data/datahelpers'
import _ from 'common-tools/LodashHelper'
import { useLocation, BaseContext } from 'common-tools/ReachRouter'
import { resolve } from 'common-tools/ReachRouter/lib/utils'

export const LayoutContentBreadCrumbNavOption = compose(
  ReduxWrapper([
    sh.SessionAccount,
    sh.SessionUser
  ])
)(
  function NavOptionPlain (props) {
    const { link, text, permissions = [], SessionAccount, SessionUser } = props
    if (_.isArray(permissions) && permissions.length > 0) {
      if (!(SessionAccount.HasPermissions(permissions) || SessionUser.HasPermissions(permissions))) {
        return null
      }
    }

    return <option value={link}>{text}</option>
  })

// ------------------------ Main Export --------------------------
export const LayoutContentBreadCrumbs = compose(
  ReduxWrapper([
    sh.SessionAccount,
    sh.SessionUser,
    sh.LayoutContentBreadCrumbKeys,
    sh.IndexRoutes
  ], [
    ah.sendToURL
  ])
)(function LayoutContentBreadCrumbsPlain (props) {
  const { LayoutContentBreadCrumbKeys, navs, IndexRoutes, children, sendToURL } = props
  const location = useLocation()
  const baseContext = useContext(BaseContext)

  const [selectedPath, setSelectedPath] = useState()

  useEffect(() => {
    if (selectedPath !== currentPageNav) {
      sendToURL(resolve(selectedPath, baseContext.baseuri))
    }
  }, [selectedPath])

  const [breadcrumbs, setBreadCrumbs] = useState()

  useEffect(() => {
    let currentURL = ''
    const urlParts = _.split(_.join(_.drop(location.pathname), ''), '/')

    if (urlParts.length < 1) {
      return null
    }

    const lastPartIndex = urlParts.length - 1

    const builtCrumbs = _.map(urlParts, (p, i) => {
      if (p) {
        let v = p

        let breadCrumbKey = _.find(LayoutContentBreadCrumbKeys, { key: p })
        if (breadCrumbKey) {
          v = breadCrumbKey.value
        }

        currentURL = currentURL + `/${p}`

        let crumbContents = <RouteLink key={i} to={currentURL}>{v}</RouteLink>

        if (i === lastPartIndex) {
          crumbContents = <span key={i}>{v}</span>
        }

        if (breadCrumbKey) {
          if (breadCrumbKey.disabled) {
            crumbContents = <span key={i}>{v}</span>
          }
        }
        return crumbContents
      }
    })

    setBreadCrumbs(builtCrumbs)
  }, [location, LayoutContentBreadCrumbKeys, IndexRoutes])

  const [navOptions, setNavOptions] = useState()
  const [currentPageNav, setCurrentPageNav] = useState()

  useEffect(() => {
    if (_.isArray(navs) === true) {
      var items = navs
    } else if (_.isFunction(children)) {
      var items = children(baseContext.baseuri, location.pathname)
    } else {
      return children
    }

    let matchPageNav = ''
    if (items.length > 0) {
      var userNavs = _.map(items, (n, i) => {
        if (!matchPageNav) {
          console.log(resolve(n.link, baseContext.baseuri))
          if (resolve(n.link, baseContext.baseuri) === location.pathname) {
            matchPageNav = n.link
          }
        }
        return <LayoutContentBreadCrumbNavOption {...n} key={i} />
      })
    } else {
      var userNavs = []
    }

    setNavOptions(userNavs)

    if (matchPageNav) {
      setCurrentPageNav(matchPageNav)
      setSelectedPath(matchPageNav)
    }
  }, [navs, children, baseContext])

  return <Grid paddingX className='nav-hed-btm-margin'>
    <GridCell small={9} className='hed-breadcrumbs'>
      {_.map(breadcrumbs, (b, i) => {
        if (i === 0) {
          return b
        } else {
          return [' / ', b]
        }
      })}
    </GridCell>
    {navOptions?.length > 0
      ? <GridCell small={3}>
        <label>
          <select value={selectedPath} onChange={(e) => { setSelectedPath(e.target.value) }}>
            {navOptions}
          </select>
        </label>
      </GridCell>
      : null
    }

  </Grid>
})
